<template>
  <div class="list-item" :class="{ clickable: clickable, 'full-width': windowWidth < 1200 }">
    <div class="align-items-center">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    clickable: {
      type: Boolean,
    },
    windowWidth: { type: Number },
  },
};
</script>

<style scoped lang="scss">
.list-item {
  background: white;
  padding: 1rem;
  border-radius: $border-radius-medium;
  border: 1px solid $gray-300;
  box-shadow: $box-shadow-2;
  transition: $transition-base;
  display: inline-block;
  width: calc(50% - 20px);
  margin: 10px;
}

.full-width {
  width: 100%;
  margin: 10px 0;
}

.clickable {
  cursor: pointer;
}

.list-item:hover {
  box-shadow: $box-shadow-3;
}
</style>
